import { type ReactNode, type Ref, type SyntheticEvent, forwardRef, useRef } from 'react';

import { mergeRefs } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';
import reactToText from 'react-to-text';

import { styledTileItemRecipe, StyledTileItemVariants, tileItemContainerClass } from './FeaturePreviewItem.css';

type ItemProps = {
  onClick?(e: SyntheticEvent): void;
  children: ReactNode;
} & StyledTileItemVariants;

export const FeaturePreviewItem = forwardRef<HTMLAnchorElement, ItemProps>(({ children, onClick, isSelected }, ref) => {
  const localRef: Ref<HTMLButtonElement | HTMLAnchorElement> = useRef(null);
  const mergedRef = mergeRefs([ref, localRef]);

  return (
    <li>
      <button
        className={getClassNames(styledTileItemRecipe({ isSelected }))}
        data-label={reactToText(children)}
        onClick={onClick}
        ref={mergedRef as Ref<HTMLButtonElement>}>
        <div className={tileItemContainerClass}>{children}</div>
      </button>
    </li>
  );
});
